import React from "react";
import svgUrl from "/Users/mrp/Documents/XSwapProtocol/v3-swap/src/assets/svg/dot_line.svg?url";
const SvgDotLine = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: "100%",
  height: 35,
  viewBox: "850 0 300 200",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("line", {
  x1: 0,
  x2: 3e3,
  y1: 100,
  y2: 100,
  stroke: "currentColor",
  strokeWidth: 20,
  strokeLinecap: "round",
  strokeDasharray: "1, 45"
}));
export {SvgDotLine as ReactComponent};
export default svgUrl;
